import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    button: {
        '& span': {
            textTransform: 'none'
        },

        '&.MuiButton-sizeSmall': {
            borderWidth: '1px',
            px: 3,
            py: 1
        },

        borderRadius: 12,
        borderWidth: '2px',
        px: 5,
        py: 2,
        textTransform: 'none',
        transition: 'color .2s ease-out, background-color .2s ease-in, transform .2s ease'
    },

    contained: {
        '&:hover, &:focus-visible': {
            textDecoration: 'none !important',
            transform: 'scale(1.03)'
        }
    },

    fullWidth: {
        width: {
            md: 'auto',
            xs: '100%'
        }
    },

    outlined: {
        '&:hover': {
            textDecoration: 'none !important',
            transform: 'scale(1.03)'
        }
    },

    text: {
        '&:hover': {
            textDecoration: 'underline'
        },

        backgroundColor: 'transparent !important',
        padding: '0 !important',
        textDecoration: 'underline',
        whiteSpace: 'pre-line'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
